import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
  TranslateLoader,
  TranslateModule,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { CharactersAndNumbersDirective } from "./directives/characters-and-numbers.directive";
import { DragDropDirective } from "./directives/drag-drop.directive";
import { OnlyCharactersDirective } from "./directives/only-characters.directive";
import { OnlyLowerCaseCharactersDirective } from "./directives/only-lower-case-characters.directive";
import { OnlyNumbersDirective } from "./directives/only-numbers.directive";
import { PreventDoubleClickDirective } from "./directives/prevent-double-click.directive";
import { ConversationTimeFormatPipe } from "./pipe/conversation-time-format.pipe";
import { DefaultValuePipe } from "./pipe/default-value.pipe";
import { DictionaryPipe } from "./pipe/dictionary.pipe";
import { HubLabelPipe } from "./pipe/hub-label.pipe";
import { LabelDictionaryPipe } from "./pipe/label-dictionary.pipe";
import { LinkifyPipe } from "./pipe/linkify.pipe";
import { PriceFormatPipe } from "./pipe/price-format.pipe";
import { SharedTableComponent } from "./shared-table/shared-table.component";
import { EmptyStateComponent } from "./empty-state/empty-state.component";
import { NotFoundViewComponent } from "./not-found-view/not-found-view.component";
import { ExportReadyBannerComponent } from "./export-ready-banner/export-ready-banner.component";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(
    http,
    "./assets/i18n/",
    ".json?v=20261012-courier-card-2",
  );
}

@NgModule({
  declarations: [
    OnlyNumbersDirective,
    OnlyCharactersDirective,
    OnlyLowerCaseCharactersDirective,
    CharactersAndNumbersDirective,
    LabelDictionaryPipe,
    PreventDoubleClickDirective,
    DefaultValuePipe,
    DragDropDirective,
    DictionaryPipe,
    HubLabelPipe,
    ConversationTimeFormatPipe,
    SharedTableComponent,
    LinkifyPipe,
    PriceFormatPipe,
  ],
  imports: [
    CommonModule,
    MatTooltipModule,
    NgxSkeletonLoaderModule,
    HttpClientModule,
    TranslateModule,
    DragDropModule,
    EmptyStateComponent,
    NotFoundViewComponent,
    ExportReadyBannerComponent,
  ],
  exports: [
    CommonModule,
    MatTooltipModule,
    NgxSkeletonLoaderModule,
    OnlyNumbersDirective,
    OnlyCharactersDirective,
    OnlyLowerCaseCharactersDirective,
    CharactersAndNumbersDirective,
    LabelDictionaryPipe,
    PreventDoubleClickDirective,
    DefaultValuePipe,
    DragDropDirective,
    TranslateModule,
    DictionaryPipe,
    HubLabelPipe,
    ConversationTimeFormatPipe,
    SharedTableComponent,
    LinkifyPipe,
    PriceFormatPipe,
    DragDropModule,
    EmptyStateComponent,
    NotFoundViewComponent,
    ExportReadyBannerComponent,
  ],
})
export class SharedModule {}
